module.exports = __webpack_public_path__ + "static/CIW_Part1-5e929f08bc93370b8cf4609419358d4d.pdf";